import NamaCommon, {NamaAxiosRequestConfig} from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import PlaceTokens from "@/utils/constants/PlaceTokens.ts";
import ClientCache from "@/utils/login/ClientCache.ts";
import ViewMode from "@/utils/constants/ViewMode.ts";
import ListPlace from "@/utils/presenters/ListPlace.ts";
import SecurityUtils from "@/utils/login/SecurityUtils.ts";
import CapabilityType from "@/utils/constants/CapabilityType.ts";
import {useErrorsStore} from "@/stores/ToastDataStore.ts";
import Translator from "@/utils/common/Translator.ts";
import BSCEntities from "@/utils/constants/BSCEntities.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import EntityTypesUtils from "@/utils/common/EntityTypesUtils.ts";
import EntitiesWithLedgerEffectsOrWithParents from "@/utils/constants/EntitiesWithLedgerEffectsOrWithParents.ts";
import GenericActions from "@/utils/constants/GenericActions.ts";
import CommonConstants from "@/utils/constants/CommonConstants.ts";
import MoreMenuItem from "@/utils/UIConstants/MoreMenuItem.ts";
import {GridApi} from "ag-grid-community";
import AGGridUtils from "@/utils/UIConstants/AGGridUtils.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import ActionHandler from "@/utils/moreMenu/ActionHandler.ts";
import GUIUtilities from "@/utils/common/GUIUtilities.ts";
import RouteNames from "@/router/RouteNames.ts";
import PrintingOption from "@/utils/constants/PrintingOption.ts";
import NamaPrinting from "@/utils/common/NamaPrinting.ts";
import OutputFormat from "@/utils/constants/OutputFormat.ts";
import BusinessFunction from "@/utils/constants/BusinessFunction.ts";
import PrintAsDialog from "@/components/dialogs/PrintAsDialog.vue";
import {Dialog} from "quasar";
import DialogHandler, {CommonDialogAction} from "@/utils/forms/DialogHandler.ts";
import ReportViewerPresenter, {EmailSenderDialogType} from "@/utils/presenters/ReportViewerPresenter.ts";
import IdsAndConstants from "@/utils/UIConstants/IdsAndConstants.ts";
import RepOutputFormat from "@/utils/constants/RepOutputFormat.ts";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import {EditPresenter} from "@/utils/presenters/EditPresenter.ts";
import {QuestionFieldsPresenter} from "@/utils/presenters/QuestionFieldsPresenter.ts";
import {WidgetsPresenter} from "@/utils/presenters/interfaces.ts";
import ListViewPerformer from "@/utils/presenters/ListViewPerformer.ts";
import ListPresenter from "@/utils/common/ListPresenter.ts";
import {ProcessCellForExportParams} from "ag-grid-enterprise";
import AGGridRefOrGenRefColumn from "@/utils/UIConstants/AGGridColumns/AGGridRefOrGenRefColumn.ts";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import GridExporter from "@/utils/common/GridExporter.ts";
import ShowCustomRepIn from "@/utils/constants/ShowCustomRepIn.ts";
import CustomReportLauncherAction from "@/utils/editView/editScreens/CustomReportLauncherAction.ts";
import router from "@/router";
import PrintReportRequest = namaTypes.PrintReportRequest;
import QuestionField = namaTypes.QuestionField;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import ListViewActionPlaceHolder = namaTypes.ListViewActionPlaceHolder;
import CustomRepInfo = namaTypes.CustomRepInfo;

export default class ListViewToolbarUtils {
  static async onNewRecord(givenQuery: Record<string, any>, shouldOpenInNewTab?: boolean) {
    let query = ObjectChecker.getFirstNotEmptyObj(givenQuery, router.currentRoute.value.query);
    for (let key in query) {
      if (key === PlaceTokens.PRM_ID || key === PlaceTokens.PRM_EDIT_TEMPLATE_ID)
        delete query[key];
    }
    let menuLine = ClientCache.getMenuLineBySrc(query[PlaceTokens.PRM_MENU_HASH]);
    if (menuLine && menuLine.target && menuLine.target.defaultsTemplate && menuLine.target.defaultsTemplate.id)
      query[PlaceTokens.PRM_EDIT_TEMPLATE_ID] = menuLine.target.defaultsTemplate.id;
    query[PlaceTokens.PRM_VIEW] = ViewMode.NEW;
    if (shouldOpenInNewTab) {
      let url = router.resolve({
        name: RouteNames.EDIT_VIEW_ROUTE,
        query: query
      }).href;
      window.open(url, "_blank");
    } else {
      await router.push({
        name: RouteNames.EDIT_VIEW_ROUTE,
        query: query
      })
    }
  }

  static async print(format: string, selectedRows: any[], place: ListPlace, viewName: string | undefined, grid: GridApi) {
    let entityType = place.entityType ?? '';
    let request: PrintReportRequest = {
      printingOption: PrintingOption.NONE,
      format: format,
      entityType: entityType,
      viewName: viewName,
      menuCode: place.src,
      form: false,
    };
    let result: boolean = await ClientCache.isPrintingPossible(request);
    if (result) {
      let ids: string[] = selectedRows.map(l => l[CommonFieldIds.ID]);
      NamaPrinting.printList(entityType, ids, format, viewName, 0, place.src);
    } else {
      GridExporter.exportToPDF(grid, {fileName: entityType});
    }
  }

  static async onPrintAs(selectedRows: any[], place: ListPlace, viewName: string | undefined, grid: GridApi) {
    Dialog.create({
      component: PrintAsDialog,
      componentProps: {
        title: BusinessFunction.printAs,
      }
    }).onOk((format: string) => {
      if (format)
        if (format === BusinessFunction.sendEmailWithResult)
          this.sendEmail(place, selectedRows.map(l => l[CommonFieldIds.ID]));
        else
          this.print(format, selectedRows, place, viewName, grid);
    });
  }

  static async sendEmail(place: ListPlace, ids: string[]) {
    let okBtn: CommonDialogAction = CommonDialogAction.createOkDialogAction(async (emailInfo: Record<string, any>) => {
      if (!emailInfo)
        return;
      let format = emailInfo.outputFormat;
      let viewName = ''; // TODO:: that.view.id [js], layout.getId() [java];
      let entityType = place.entityType ?? '';
      let request: PrintReportRequest = {
        printingOption: PrintingOption.NONE,
        format: OutputFormat.PDF,
        entityType: entityType,
        viewName: viewName,
        menuCode: place.src
      };
      let result: boolean | undefined = await ClientCache.isPrintingPossible(request);
      if (!result)
        return;
      await EditPresenter.sendEmail(emailInfo, format, entityType, StringUtils.toCSVLineWithSep(",", ids), undefined, viewName, place.src, false)
    });
    let cancelBtn: CommonDialogAction = CommonDialogAction.createCancelDialogAction(() => {
    });
    let questionFields: QuestionField[] = [];
    ReportViewerPresenter.addEmailSendDialogFields(questionFields, EmailSenderDialogType.SendForm);
    let defaultValues: DTOFilledQuestionField[] = [
      {id: IdsAndConstants.outputFormat, value: RepOutputFormat.PDF, objValue: RepOutputFormat.PDF}
    ];
    let questionPresenter: QuestionFieldsPresenter = new QuestionFieldsPresenter(place.entityType);
    await questionPresenter.edit(questionFields ?? [], defaultValues ?? []);
    let dialogBox = new DialogHandler([okBtn, cancelBtn], Translator.translateId("emailSend"), false);
    await dialogBox.createPresenter(questionPresenter as WidgetsPresenter, questionFields, defaultValues);
    await dialogBox.runDialogBox();
  }

  static exportToExcel(place: ListPlace, grid: GridApi) {
    if (!SecurityUtils.userCan(place.entityType!, CapabilityType.Export)) {
      useErrorsStore().pushErrorStr(Translator.translateId("noAuthorityOnOperation")!);
      return;
    }
    grid.exportDataAsExcel({
      fileName: Translator.translateId(place.title),
      // Apply TableStyleMedium2-like styling: header style and row stripes
      headerRowHeight: 25,
      rowHeight: 20,
      processCellCallback(params: ProcessCellForExportParams): string {
        if (!params.value)
          return params.value;
        let formattedValue = params.formatValue(params.value);
        if (typeof formattedValue === 'object')
          return AGGridRefOrGenRefColumn.nameOfRef(formattedValue);
        return formattedValue;
      }
    });
  }

  static async markRevised(revised: boolean, place: ListPlace, gridApi: GridApi) {
    let selectedIds: string[] = AGGridUtils.fetchSelectedRows(gridApi).map(l => l[CommonFieldIds.ID]);
    if (!selectedIds) {
      useErrorsStore().pushErrorStr(Translator.translateId("pleaseSelectRows"));
      return;
    }
    let settings: NamaAxiosRequestConfig = {
      params: {
        id: StringUtils.toCSVLineWithSep(",", selectedIds),
        entityType: place.entityType,
        revise: revised
      }
    }
    let response = await NamaCommon.namaFetch(NamaURLS.BULK_REVISE, settings);
    if (response && !response.failureOccurred) {
      gridApi.refreshServerSide({purge: true});
      return;
    }
  }

  static isHasFilters(presenter: ListPresenter): boolean {
    if (presenter.fetchPlace().criteria)
      return true;
    const tree = presenter.criteriaTree.value;
    if (tree?.[0]?.children?.length)
      return true;
    const api = presenter.gridApi.value;
    if (api && !api.isDestroyed() && api.isAnyFilterPresent())
        return true;
    if (ObjectChecker.isNotEmptyOrNull(presenter.selectedQuickFilterGroups.value))
      return true;
    return false;
  }

  static async removeFilter(presenter: ListPresenter, api: GridApi) {
    await presenter.removeFilter(api);
  }

  static deleteSelectedRows(presenter: ListPresenter) {
    let deleteSelectedAction: MoreMenuItem = new ActionHandler({id: GenericActions.DELETE_SELECTED} as ListViewActionPlaceHolder
      , presenter.fetchMetadata(), presenter.entityType, new ListViewPerformer(presenter)).toMoreMenuItem();
    if (deleteSelectedAction && deleteSelectedAction.executeFn)
      deleteSelectedAction.executeFn();
  }

  static getListViewMoreMenuItems(presenter: ListPresenter): MoreMenuItem[] {
    let place = presenter.fetchPlace();
    if (!SecurityUtils.userCan(place.entityType!, CapabilityType.CanViewMoreMenu))
      return [];
    let moreActions: namaTypes.ListViewActionPlaceHolder[] = [];
    let listLayout = presenter.layout;
    if (!listLayout)
      return [];
    if (listLayout.moreActions)
      moreActions.push(...listLayout.moreActions);
    if (!listLayout.hideEntitySpecificFeatures) {
      if (moreActions.length > 0)
        moreActions.push({
          id: CommonConstants.MORE_MENU_SEPERATOR
        });
      moreActions.push(...this.getStandardMoreActions(place.entityType!));
      if (useNamaFlagsStore().replicationOptionsActive) {
        moreActions.push({id: GenericActions.RECOMMIT});
        moreActions.push({id: GenericActions.REVERT_TO_PREVIOUS_VERSION});
        moreActions.push({id: GenericActions.REVERT_TO_VERSION_AT_SPECIFIC_TIME});
        if (GUIUtilities.isEntityWithAccountingEffect(place.entityType!)) {
          moreActions.push({id: GenericActions.REGEN_ACCOUNTING_EFFECTS});
          moreActions.push({id: GenericActions.CHANGE_VALUE_DATE_FOR_SELECTED_DOCUMENTS});
        }
        if (EntityTypesUtils.isDocument(place.entityType!)) {
          moreActions.push({id: GenericActions.REGEN_INVENTORY_EFFECTS});
        }
        if (ObjectChecker.areEqual(place.entityType, BSCEntities.ReportDefinition)) {
          moreActions.push({id: "updateSystemReports"});
        }
        if (ObjectChecker.isAnyEqualToFirst(place.entityType!, ...EntitiesWithLedgerEffectsOrWithParents.HAS_ACTIVATED_ENTITIES))
          moreActions.push({id: "cancelActivated"});
      }
      moreActions.push({id: GenericActions.LIST_VIEW_ADD_TO_CURRENT_USER_FAVOURITES});
      moreActions.push({id: GenericActions.ADD_SELECTED_DOCS_TO_LINES_OF_CURRENT_USER_FAVOURITE});
    }
    if (SecurityUtils.userCan(BSCEntities.ScreenModifier, CapabilityType.EditAfterCommit))
      moreActions.push({id: GenericActions.OPEN_SCREEN_MODIFIER_FOR_LIST_VIEW});
    const moreMenuItems: MoreMenuItem[] = [];
    moreMenuItems.push(MoreMenuItem.createMoreMenuItem('showErrors', presenter.showErrorsExecuteFn));
    if (moreActions.length > 0) {
      for (let moreAction of moreActions) {
        if (moreAction.id || moreAction.customization !== null)
          moreMenuItems.push(new ActionHandler(moreAction, presenter.fetchMetadata(), place.entityType!, new ListViewPerformer(presenter))
            .toMoreMenuItem());
      }
    }
    if (useNamaFlagsStore().replicationOptionsActive) {
      if (ObjectChecker.areEqual(listLayout.type, "QueryObjectBased")) {
        let queriedClass = listLayout.queriedClass;
        let entityType: string;
        if (ObjectChecker.isEmptyOrNull(queriedClass)) {
          entityType = listLayout.owner?.ownerId!;
        } else {
          let parts: string[] = queriedClass!.split("\\.");
          entityType = parts[parts.length - 1];
        }
        moreMenuItems.push(this.createEntityDMMenuItem(entityType));
      } else {
        moreMenuItems.push(this.createEntityDMMenuItem(place.entityType!));
      }
      if (ObjectChecker.areEqual(place.entityType, BSCEntities.ReportDefinition)) {
        moreMenuItems.push(MoreMenuItem.createMoreMenuItem("openImplementationRepo", () => {
          window.open("https://crm.namasoft.com/erp/repobrowser.html?exportTo=" + window.location.href.substring(0, window.location.href.indexOf('#'))
            , "_blank")
        }));
      }
    }
    if (moreMenuItems.length > 0) {
      moreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
    }
    if (!listLayout.hideEntitySpecificFeatures) {
      if (ClientCache.getCustomGUISettings()?.showOldBarcodeMenu) {
        moreMenuItems.push(MoreMenuItem.createMoreMenuItem("printBarcodeForSelected", () => {
          // TODO
          // printBarcode(AGGridUtils.fetchSelectedRows(gridAPI))
        }));
        moreMenuItems.push(MoreMenuItem.createMoreMenuItem("printBarcodeForPage", () => {
          // TODO
          // printBarcode(page);
        }));
      }
      moreMenuItems.push(MoreMenuItem.createMoreMenuItem("printSelectedRows", () => {
        // TODO
        // onPrint(OutputFormat.PDF, getListIds(getSelectedObjects()))
      }));
      moreMenuItems.push(MoreMenuItem.createMoreMenuItem("printBarcodeForSelected", () => {
        let selectedIds = AGGridUtils.fetchSelectedRows(presenter.gridApi.value!).map(l => l.id);
        for (let id of selectedIds) {
          // TODO
          // NamaPrinting.printForm(place.entityType, id, {resourceId: "main"} as namaTypes.NaMaText, OutputFormat.PDF, layout.getId(), 0, place.src, true);
        }
      }));
    }
    let entityCustomReports: CustomRepInfo[] = ClientCache.getEntityCustomReports(place.entityType);
    if (entityCustomReports && entityCustomReports.length > 0) {
      moreMenuItems.push(MoreMenuItem.createSeperatorMenuItem());
      for (let customRepInfo of entityCustomReports) {
        if (ObjectChecker.areEqual(customRepInfo.showIn, ShowCustomRepIn.ListViewMore)) {
          let menuItem = new MoreMenuItem();
          menuItem.text = Translator.translateNaMaText(customRepInfo.title, place.entityType);
          menuItem.id = customRepInfo.reportId;
          menuItem.executeFn = async () => {
            let action = new CustomReportLauncherAction(presenter, customRepInfo);
            if (action.executeFn)
              await action.executeFn();
          };
          moreMenuItems.push(menuItem);
        }
      }
    }
    return moreMenuItems;
  }

  static createEntityDMMenuItem(entityType: string): MoreMenuItem {
    let menuItem = new MoreMenuItem();
    menuItem.text = Translator.translateId("showEntityDM")!;
    menuItem.id = "showEntityDM";
    menuItem.executeFn = () => {
      window.open("https://dm.namasoft.com#" + entityType, "_blank")
    }
    return menuItem;
  }

  static getStandardMoreActions(entityType: string): namaTypes.ListViewActionPlaceHolder[] {
    let actionPlaceholders: namaTypes.ListViewActionPlaceHolder[] = [];
    actionPlaceholders.push({id: GenericActions.DELETE_SELECTED});
    actionPlaceholders.push({id: GenericActions.CREATE_LIST_VIEW_CRITERIA});
    actionPlaceholders.push({id: CommonConstants.MORE_MENU_SEPERATOR});
    if (SecurityUtils.userCan(entityType, CapabilityType.Import))
      actionPlaceholders.push({id: GenericActions.IMPORT_RECORDS});
    if (SecurityUtils.userCan(entityType, CapabilityType.Export)) {
      actionPlaceholders.push({id: GenericActions.EXPORT_SELECTED});
      actionPlaceholders.push({id: GenericActions.EXPORT_PAGE});
      actionPlaceholders.push({id: GenericActions.EXPORT_ALL});
    }
    actionPlaceholders.push({id: GenericActions.SAVE_DRAFT_RECORDS});
    actionPlaceholders.push({id: GenericActions.PREVENT_USAGE});
    actionPlaceholders.push({id: GenericActions.ALLOW_USAGE});
    return actionPlaceholders;
  }

  static supportsTreeViewInListView(entityType: string): boolean {
    if (EntityTypesUtils.isMaster(entityType))
      return true;
    return false;
  }
}
